import {Injectable} from '@angular/core';
import {CanMatchFn, Route, UrlSegment, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {SharedService} from './shared.service';

@Injectable({
  providedIn: 'root'
})
// @ts-ignore
export class Guard implements CanMatchFn {
  constructor(
    private shared: SharedService
  ) {}

  canMatch: CanMatchFn = (route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean|UrlTree> | Promise<boolean|UrlTree> => {
    return this.shared.validarToken().pipe(
      map(isValid => {
        if (isValid) return true;
        this.shared.LOGOUT();
        return false
      })
    )
  }
}
